/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

/**
 * Simple directive for phone inputs
 */
@Directive({ selector: '[oneDigit]' })
export class OneDigitDirective {

  constructor(public ngControl: NgControl) {
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

  /**
   * Allows only one digit in fields
   * @param event Getting user input from the $event object
   * @param backspace boolean param if the backspace has been hit
   * {@link https://angular.io/guide/user-input#get-user-input-from-the-event-object}
   */
  onInputChange(event, backspace): void {
    if (event) {
      const newVal = event.replace(/\D/g, '');
      this.ngControl.valueAccessor.writeValue(newVal[newVal.length - 1]);
    }
  }
}
